import ROUTES from 'routes/constants';
import { AGENTS_API_URL } from 'config';
import AuthLogin from 'containers/AuthLogin';
import { clearLocalAuthCookie } from 'routes/localAuth';
import { LOCAL_LOGIN_PATH, LOCAL_LOGOUT_PATH } from 'routes/localPaths';

const safeLogoutRedirect = () => {
  const urlSearch = new URLSearchParams(window.location.search);
  const redirectPath = urlSearch.get('redirect');

  if (!redirectPath) return LOCAL_LOGIN_PATH;

  try {
    const parsed = new URL(redirectPath, window.location.origin);
    if (parsed.origin === window.location.origin) {
      return `${LOCAL_LOGIN_PATH}?redirect=${encodeURIComponent(
        `${parsed.pathname}${parsed.search}${parsed.hash}`,
      )}`;
    }
  } catch (error) {
    if (redirectPath.startsWith('/') && !redirectPath.startsWith('//')) {
      return `${LOCAL_LOGIN_PATH}?redirect=${encodeURIComponent(
        redirectPath,
      )}`;
    }
  }

  return LOCAL_LOGIN_PATH;
};

export default function createRoutes() {
  return [
    {
      path: LOCAL_LOGIN_PATH,
      name: 'login',
      component: AuthLogin,
    },
    {
      path: '/login',
      name: 'legacy-login',
      component: AuthLogin,
    },
    {
      path: ROUTES.ACCESS_CODE,
      name: 'access-code',
      component: AuthLogin,
    },
    {
      path: ROUTES.CONFIRM_ACCOUNT_PATH,
      name: 'confirm-account',
      component: AuthLogin,
    },
    {
      path: ROUTES.CREATE_ACCOUNT_PATH,
      name: 'create-account',
      component: AuthLogin,
    },
    {
      path: ROUTES.VERIFY_EMAIL_PATH,
      name: 'verify-email',
      component: AuthLogin,
    },
    {
      path: LOCAL_LOGOUT_PATH,
      name: 'logout',
      async onEnter() {
        try {
          await fetch(`${AGENTS_API_URL}/auth/logout`, {
            method: 'POST',
            credentials: 'include',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          });
        } catch (error) {
          // The local cookie is cleared below even if the API is unavailable.
        }

        clearLocalAuthCookie();
        window.location.replace(safeLogoutRedirect());
      },
    },
  ];
}
